<template>
  <div
    class="heading-block"
    :style="cssVars"
  >
    <div v-html="config.content" />
  </div>
</template>

<script setup>
import { computed } from 'vue';

defineOptions({
  name: 'HeadingBlock',
});

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});

const cssVars = computed(() => ({
  '--text-align': props.config.align,
}));
</script>
<style lang="scss" scoped>
.heading-block {
  text-align: var(--text-align);
  color: var(--heading-color);
}
</style>
